module.exports = __webpack_public_path__ + "img/sc_general_EN.png";